export default __webpack_public_path__ + "images/logoJohnson.1bc600b2205f2e79e900cb18fed557f3.svg"